(() => {
 'use strict';
 if (customElements.get('rlth-home-motion')) return;
 const clamp = v => Math.max(0, Math.min(1, v));
 class HomeMotion extends HTMLElement {
  connectedCallback() {
   this.abort = new AbortController(); const signal = this.abort.signal;
   this.motion = matchMedia('(prefers-reduced-motion: reduce)');
   this.scene = this.dataset.scene;
   this.stage = this.querySelector('.hc-world-stage');
   this.core = this.querySelector('[data-world-core]');
   this.strata = this.querySelector('[data-world-strata]');
   this.media = this.querySelector('[data-hero-media]');
   this.stack = this.querySelector('.hc-layer-stack');
   this.field = this.querySelector('.hc-drop-colour');
   this.schedule = () => {
    if (!this.visible || !this.enabled || document.hidden || this.frame) return;
    this.frame = requestAnimationFrame(() => { this.frame = 0; this.draw(); });
   };
   this.refresh = () => { this.configure(); this.schedule(); };
   addEventListener('resize', this.refresh, {signal, passive:true});
   addEventListener('scroll', this.schedule, {signal, passive:true});
   document.addEventListener('visibilitychange', this.schedule, {signal});
   this.motion.addEventListener('change', this.refresh, {signal});
   document.addEventListener('shopify:section:select', e => {
    if (e.target.contains(this) && this.scene === 'worlds') {
     this.scrollIntoView({block:'start',behavior:'instant'});
     this.schedule();
    }
   }, {signal});
   this.observer = new IntersectionObserver(entries => {
    this.visible = entries[0].isIntersecting; this.schedule();
   }, {rootMargin:'180px'});
   this.observer.observe(this);
   this.visible = true;
   this.configure(); this.schedule();
  }
  configure() {
   const root = document.documentElement.dataset;
   this.enabled = !this.motion.matches && root.motion !== 'false' && root.enhanced !== 'false' && root.lowPerformance !== 'true';
   if (this.scene !== 'worlds') {
    if (innerWidth < 900 && (this.scene === 'layers' || this.scene === 'hero' || this.scene === 'drop')) this.enabled = false;
    if (!this.enabled) {
     if(this.media) this.media.style.transform = '';
     if(this.stack) this.stack.style.setProperty('--hc-gap','15px');
     if(this.field) this.field.style.clipPath = ''; this.querySelectorAll('.hc-edition').forEach(card=>card.style.transform='');
    }
    return;
   }
   const header = document.querySelector('.x-header');
   const pos = header && getComputedStyle(header).position;
   const top = (pos === 'sticky' || pos === 'fixed') ? Math.min(header.getBoundingClientRect().height,140) : 0;
   const mobile = innerWidth < 900;
   if (!mobile || this.viewWidth !== innerWidth || !this.mobileViewport) this.mobileViewport = innerHeight;
   this.viewWidth = innerWidth;
   const viewportHeight = mobile ? this.mobileViewport : innerHeight;
   this.pin = this.enabled && !!this.strata && viewportHeight - top >= 560;
   this.classList.toggle('is-pinned', this.pin);
   if (this.pin) {
    this.stageHeight = viewportHeight - top;
    this.startHold = this.stageHeight * .3;
    this.transitionTravel = this.stageHeight * (Number(mobile ? this.dataset.mobileDistance || 175 : this.dataset.distance || 200) / 100);
    this.endHold = this.stageHeight * .85;
    this.style.setProperty('--hc-top',top+'px');
    this.style.setProperty('--hc-stage',this.stageHeight+'px');
    this.topOffset = top;
    this.style.height = (this.stageHeight+this.startHold+this.transitionTravel+this.endHold)+'px';
   } else {
    this.style.height = '';
    if (this.strata) { this.strata.style.transform = ''; this.strata.inert = false; this.strata.removeAttribute('aria-hidden'); }
    if (this.core) { this.core.inert = false; this.core.removeAttribute('aria-hidden'); }
   }
  }
  draw() {
   const rect = this.getBoundingClientRect();
   if (this.scene === 'worlds' && this.pin) {
    const travelled = this.topOffset - rect.top;
    const progress = clamp((travelled - this.startHold) / this.transitionTravel);
    this.strata.style.transform = innerWidth < 900 ? 'translate3d(0,'+((1-progress)*100)+'%,0)' : 'translate3d('+((1-progress)*100)+'%,0,0)';
    const coreHidden = progress >= 1;
    const strataHidden = progress <= 0;
    this.core.inert = coreHidden; this.strata.inert = strataHidden;
    this.core.setAttribute('aria-hidden',String(coreHidden)); this.strata.setAttribute('aria-hidden',String(strataHidden));
   } else if (this.scene === 'hero' && this.media) {
    const p=clamp(-rect.top / Math.max(1,rect.height));
    this.media.style.transform='translate3d(0,'+(p*24)+'px,0) scale('+(1.03+p*.025)+')';
   } else if (this.scene === 'layers' && this.stack) {
    const p=clamp((innerHeight*.8-rect.top)/(rect.height*.8));
    const spread = Math.sin(p*Math.PI);
    this.stack.style.setProperty('--hc-gap',(innerWidth < 900 ? 11+spread*10 : 15+spread*18)+'px');
    } else if (this.scene === 'editions') { const cards=this.querySelectorAll('.hc-edition'); cards.forEach((card,i)=>{ const q=clamp((innerHeight-rect.top-i*65)/(innerHeight*.8)); card.style.transform='translate3d(0,'+(48*(1-q))+'px,0)'; }); } else if (this.scene === 'drop' && this.field) {
    const p=clamp((innerHeight-rect.top)/(innerHeight+rect.height));
    this.field.style.clipPath='polygon('+(72-p*16)+'% 0,100% 0,100% 100%,'+(44-p*16)+'% 100%)';
   }
  }
  disconnectedCallback() {
   this.abort?.abort(); this.observer?.disconnect(); cancelAnimationFrame(this.frame); this.frame=0;
  }
 }
 customElements.define('rlth-home-motion',HomeMotion);
})();
